var _rect, _line, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFinishIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 50 50",
    height: "50px",
    id: "Layer_1",
    viewBox: "0 0 50 50",
    width: "50px",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    height: 50,
    width: 50
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#00AA00",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    x1: 18.594,
    x2: 3.373,
    y1: 47.92,
    y2: 5.407
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "  M4.448,8.409c0,0,5.911-6.409,16.179-6.409c6.25,0,9.106,4.073,14.264,4.073C40.046,6.073,44.998,2,44.998,2v26.471  c0,0-3.723,2.037-8.146,2.037c-4.421,0-6.225-2.037-12.217-2.037c-5.683,0-11.025,5.516-11.025,5.516L4.448,8.409z",
    fill: "none",
    stroke: "#00AA00",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#00AA00",
    fill: "#00AA00",
    d: "M4.448,8.409c0,0,3.067-3.248,7.207-4.584l3.164,8.124c0,0-4.086,1.47-7.422,4.605L4.553,8.709"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#00AA00",
    fill: "#00AA00",
    d: "M14.819,11.949l3.412,8.759c0,0,2.683-0.954,4.53-0.954s3.678,0.271,3.678,0.271l-2.477-9.315c0,0-0.7-0.099-1.563-0.099  C18.264,10.611,14.819,11.949,14.819,11.949z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#00AA00",
    fill: "#00AA00",
    d: "M10.72,25.776l2.89,8.21c0,0,3.997-3.832,7.804-4.91l-3.182-8.368C14.566,22.12,10.72,25.776,10.72,25.776z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#00AA00",
    fill: "#00AA00",
    d: "M21.676,2.111l2.287,8.598c1.85,0,6.994,2.521,6.994,2.521l-2.028-8.879C27.766,3.916,24.721,2.255,21.676,2.111z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    stroke: "#00AA00",
    fill: "#00AA00",
    d: "M26.439,20.024l2.355,8.851c1.186,0,4.586,1.449,6.065,1.449l-1.988-8.702C30.957,21.124,27.859,20.223,26.439,20.024z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    stroke: "#00AA00",
    fill: "#00AA00",
    d: "M30.957,13.231l1.915,8.392c0,0,1.916,0.354,3.231,0.354c1.314,0,2.953-0.298,2.953-0.298l-0.622-7.684  c0,0-1.269,0.394-2.807,0.394C33.225,14.389,30.957,13.231,30.957,13.231z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    stroke: "#00AA00",
    fill: "#00AA00",
    d: "M37.762,5.671l0.673,8.323c0,0,3.129-0.786,6.565-3.384L44.998,2C41.053,5.022,37.762,5.671,37.762,5.671z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    stroke: "#00AA00",
    fill: "#00AA00",
    d: "M39.057,21.679c0,0,3.014-0.559,5.941-2.259v9.051c-3.117,1.496-5.261,1.767-5.261,1.767L39.057,21.679z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinishIcon);
export default __webpack_public_path__ + "static/media/finish_icon.160508042ebe3a921d8347cbb5f72db8.svg";
export { ForwardRef as ReactComponent };